<div class="settings-page" #settingsContainer>
  <div class="content-center" [class.overlay-open]="showInlineEditor">
    
    <div class="tabs-row" *ngIf="!isLoading">
      <div class="section-title">Departments</div>
      <a class="add-new" (click)="openNewEditor()">New Department</a>
    </div>

    <div class="new-footer-inline" *ngIf="showInlineEditor && !isLoading">
      <div class="new-footer-header">
        <div class="title">{{ isEditMode ? 'Edit Department' : 'New Department' }}</div>
        <button type="button" class="modal-close" aria-label="Close" (click)="closeInlineEditor()">
          <span class="material-icons">close</span>
        </button>
      </div>

      <form [formGroup]="form">
        
        <div class="row">
          <div class="col">
            <wm-common-textfield 
              formControlName="name" 
              [data]="{ label: 'Department Name', placeholder: 'Enter name', required: true, helperText: 'Name is required' }">
            </wm-common-textfield>
          </div>

          <div class="col top-actions-col">
            <div class="inline-action-item">
              <label class="toggle-item">
                <span class="field-label inline-label mb-0">Enabled</span>
                <input type="checkbox" class="native-toggle" formControlName="enabled" />
              </label>
            </div>
            
            <div class="inline-action-item" *ngIf="isEditMode && currentEditingDept">
              <button type="button" class="btn-delete-inline" (click)="requestDelete(currentEditingDept)">
                Delete Department <span class="material-icons">delete_outline</span>
              </button>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <wm-common-textfield 
              formControlName="description" 
              [data]="{ label: 'Description', placeholder: 'Enter description' }">
            </wm-common-textfield>
          </div>

          <div class="col">
            <div class="custom-select-container">
              <div class="icon-floating-label" [style.color]="showIconMenu ? '#3f51b5' : 'rgba(0,0,0,0.6)'">Icon</div>
              
              <div class="input select-trigger" (click)="toggleIconMenu()" [class.active]="showIconMenu">
                <span class="selected-text">{{ getSelectedIconLabel() }}</span>

                <span class="material-icons input-icon-preview" *ngIf="form.get('icon')?.value">
                  {{ form.get('icon')?.value }}
                </span>

                <span class="custom-arrow"></span>
              </div>

              <div class="custom-options-list" *ngIf="showIconMenu">
                <div class="option-item" *ngFor="let i of availableIcons" (click)="selectIcon(i.value)">
                  {{ i.label }}
                </div>
              </div>
            </div>

            <div class="dropdown-backdrop" *ngIf="showIconMenu" (click)="closeIconMenu()"></div>
          </div>
        </div>


<div class="document-review-content">
              <label class="toggle-item doc-review-toggle">
              <span class="field-label mb-0">Require Document Review</span>
              <input type="checkbox" class="native-toggle doc-review-margin" formControlName="requireDocumentReview" />
            </label>
            <small class="helper-text-muted">
              When enabled, documents uploaded to workflow applications in this department
              without a specific data entity will require staff review by default.
            </small>
</div>
        <div class="form-divider"></div>
        <div class="row">
          <div class="col">
            <wm-common-textfield 
              formControlName="address1" 
              [data]="{ label: 'Address Line 1', placeholder: 'Enter street address' }">
            </wm-common-textfield>
          </div>

          <div class="col">
            <wm-common-textfield 
              formControlName="address2" 
              [data]="{ label: 'Address Line 2', placeholder: 'Suite, Apt, Floor, etc.' }">
            </wm-common-textfield>
          </div>
        </div>

    
<div class="address-details">
              <wm-common-textfield 
              formControlName="city" 
              [data]="{ label: 'City', placeholder: 'Enter city' }">
            </wm-common-textfield>
                            <wm-common-textfield 
                  formControlName="state" 
                  [data]="{ label: 'State', placeholder: 'Enter state' }">
                </wm-common-textfield>
                                <wm-common-textfield 
                  formControlName="zip" 
                  [data]="{ label: 'Zip', placeholder: 'Zip code' }">
                </wm-common-textfield>
</div>
        <div class="row">
          <div class="col">
            <wm-common-textfield 
              formControlName="phone" 
              [data]="{ label: 'Phone Number', placeholder: 'Enter phone number' }">
            </wm-common-textfield>
          </div>

          <div class="col">
            <wm-common-textfield 
              formControlName="fax" 
              [data]="{ label: 'Fax Number', placeholder: 'Enter fax number' }">
            </wm-common-textfield>
          </div>
        </div>
      </form>

      <!-- Added by Amisha on 04/24/2026: render the applications grid dataset editor outside the department form so the common dynamic table can be reused here without closing edit mode. -->
      <div class="dataset-designer-section" *ngIf="isEditMode && currentEditingDept?.id">
        <div class="dataset-designer-card" #datasetDesignerCard>
          <div class="dataset-designer-header">
            <div class="dataset-designer-title">Applications Grid Dataset</div>
          </div>

          <!-- Dataset grid loader -->
          <div class="dataset-loader-container" *ngIf="isDatasetLoading">
            <div class="spinner-border custom-blue-spinner" role="status"></div>
            <span class="loading-text mt-2">Loading dataset...</span>
          </div>

          <ng-container *ngIf="!isDatasetLoading && dataSetConfig">
            <div #commonDynamicTableAnchor>
              <wm-common-dynamic-table
                [rows]="rows"
                [columns]="columns"
                [availableWorkflows]="availableWorkflows"
                [entities]="cellDropdownEntities"
                [dataSetConfig]="dataSetConfig"
                [isNoData]="isNoData"
                [hasFewData]="hasFewData"
                [workflowDisplayNameFn]="workflowDisplayNameResolver"
                (addWorkflowRequested)="addWorkflow()"
                (deleteWorkflowRequested)="deleteWorkflow($event)"
                (workflowSelected)="selectWorkflow($event.index, $event.workflow)"
                (columnSettingsRequested)="openColumnSettingsModal()"
                (columnEditRequested)="editColumn($event)"
                (columnDeleteRequested)="deleteColumn($event)"
                (columnMoveLeftRequested)="moveColumnLeft($event)"
                (columnMoveRightRequested)="moveColumnRight($event)"
                (columnReordered)="reorderColumn($event)"
                (cellDropdownOpened)="openCellDropdown($event.row, $event.column)"
                (cellEntitySelected)="selectCellEntity($event.row, $event.column, $event.entity)"
                (cellValueDeleted)="deleteCellValue($event.row, $event.column, $event.index)"
                (rowFiltersChanged)="onRowFiltersChange2($event.event, $event.row)">
              </wm-common-dynamic-table>
            </div>

            <!-- Added by Amisha on 04/24/2026: mirror the Reports dataset actions in Settings Departments for test, save draft, and publish flows. -->
            <div class="dataset-btns">
              <div class="test-save-btn">
                <wm-common-button [data]="{
                    text: isTestingDataSet ? 'TESTING...' : 'TEST DATA SET',
                    onClick: testDepartmentDataSet.bind(this),
                    disabled: isTestingDataSet || isSavingDataSetDraft || isPublishingDataSet
                  }"></wm-common-button>
              </div>
              <div class="test-save-btn">
                <wm-common-button [data]="{
                    text: isSavingDataSetDraft ? 'SAVING...' : 'SAVE DATA SET',
                    onClick: saveDepartmentDataSetOnly.bind(this),
                    disabled: isTestingDataSet || isSavingDataSetDraft || isPublishingDataSet
                  }"></wm-common-button>
              </div>
              <div class="publish-btn">
                <wm-common-button [data]="{
                    text: isPublishingDataSet ? 'PUBLISHING...' : 'PUBLISH DATA SET',
                    onClick: onOpenPublishData.bind(this),
                    disabled: isTestingDataSet || isSavingDataSetDraft || isPublishingDataSet
                  }"></wm-common-button>
                <wm-common-confirmation-modal
                  [data]="publishDataSetModalData"
                  (onNoClick)="onClosePublishData()"
                  (onYesClick)="publishDepartmentDataSet()"
                  [isApplicantMobileview]="true"
                  >
                </wm-common-confirmation-modal>
              </div>
            </div>

            <app-loader *ngIf="isTestingDataSet"></app-loader>

            <!-- Added by Amisha on 04/24/2026: show test API results under the shared dataset table with the same preview pattern used in Reports. -->
            <div class="card test-results-card" *ngIf="resultColumns && resultRows">
              <div class="test-results-header">
                <div class="test-results-title">
                  <wm-common-text [data]="{ text: 'Test Data Set Results' }"></wm-common-text>
                </div>
                <button
                  type="button"
                  class="test-results-close-btn"
                  aria-label="Close test results"
                  (click)="closeTestResults()">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
              <div class="card-body">
                <wm-common-table
                  tableType="Staff"
                  [columns]="resultColumns"
                  [data]="resultRows"
                  [defaultPageSize]="10"
                  [showRowsPerPage]="true">
                </wm-common-table>
              </div>
            </div>

            <!-- Added by Amisha on 04/24/2026: reuse the shared column settings modal with a local top offset so it stays visible within the department editor card. -->
            <wm-column-settings
              *ngIf="isColumnSettingsOpen"
              [workflowId]="selectedColumnSettingsWorkflowId"
              [field]="selectedColumnSettingsField"
              [containedOverlay]="true"
              [overlayTopOffsetPx]="columnSettingsTopOffsetPx"
              (saveColumn)="handleColumnSettingsSave($event)"
              (closePanel)="closeColumnSettingsModal()">
            </wm-column-settings>
          </ng-container>
        </div>
      </div>

      <ng-container *ngIf="isEditMode && (showTestingControls$ | async)">
        <div class="form-divider"></div>
        <div class="section-title mb-3">API Testing Controls</div>

        <div class="test-controls-container">
          
          <div class="mb-4">
            <button type="button" class="btn save btn-primary-test" (click)="testGetDepartmentApplications()" [disabled]="testingApi">
              <span class="spinner-border spinner-border-sm me-2" *ngIf="testingApi"></span>
              {{ testingApi ? 'TESTING...' : 'TEST GET DEPARTMENT APPLICATIONS API' }}
            </button>
          </div>

          <div class="test-section">
            <div class="test-section-title">Select Columns to Return:</div>
            <div class="test-card">
              <div *ngIf="availableColumns.length === 0" class="info-alert">
                <span class="material-icons info-icon">info</span>
                <span><strong>No columns available.</strong> Please configure the Applications Grid Dataset first.</span>
              </div>
              
              <div *ngIf="availableColumns.length > 0">
                <label class="custom-checkbox-wrapper select-all-wrap">
                  <input type="checkbox" [(ngModel)]="selectAllColumns" [ngModelOptions]="{standalone: true}" (change)="toggleAllColumns()">
                  <span class="checkmark"></span>
                  <span class="cb-label fw-bold">Select All Columns ({{ selectedColumns.length }} of {{ availableColumns.length }} selected)</span>
                </label>
                <small class="helper-text-muted mt-1 d-block">
                  Selecting specific columns will reduce the data returned from the API call. If all are selected, no column filtering is applied.
                </small>
                
                <div class="custom-hr"></div>
                
                <div class="columns-grid">
                  <label class="custom-checkbox-wrapper" *ngFor="let column of availableColumns">
                    <input type="checkbox" [checked]="isColumnSelected(column.name)" (change)="toggleColumnSelection(column.name)">
                    <span class="checkmark"></span>
                    <span class="cb-label">{{ column.label }}</span>
                  </label>
                </div>

                <div class="selected-columns-alert" *ngIf="!selectAllColumns && selectedColumns.length > 0">
                  <small>
                    API will return only these {{ selectedColumns.length }} column(s):
                    <strong>{{ selectedColumns.join(', ') }}</strong>
                  </small>
                </div>

              </div>
            </div>
          </div>

          <div class="test-section mt-4">
            <div class="test-section-title">Test Simple Search (All Fields):</div>
            <div class="test-card pb-24">
              <div class="search-layout">
                <div class="search-input-col">
                  <label class="field-label">Search Value</label>
                  <div class="search-input-wrapper">
<mat-icon class="search-icon">search</mat-icon>
                 <span class="custom-placeholder" *ngIf="!simpleSearchValue"> Enter value to search across all fields... </span>
                    <input type="text" class="custom-search-input"  [(ngModel)]="simpleSearchValue" [ngModelOptions]="{standalone: true}" [disabled]="testingSimpleSearch" (keyup.enter)="testSimpleSearch()">
                  </div>
                </div>
                <div class="search-btn-col">
                  <button type="button" class="btn save w-100 search-btn-exact" (click)="testSimpleSearch()" [disabled]="testingSimpleSearch || !simpleSearchValue">
                    <span *ngIf="testingSimpleSearch">SEARCHING...</span>
                    <span *ngIf="!testingSimpleSearch">SEARCH ALL FIELDS</span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="test-section mt-4">
            <div class="test-section-title">Test Column Sorting:</div>
            <div class="test-card p-0">
              <table class="custom-table">
                <thead>
                  <tr>
                    <th>Column</th>
                    <th class="text-center">Sort Ascending</th>
                    <th class="text-center">Sort Descending</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let column of sortableColumns">
                    <td>{{ column.label }}</td>
                    <td >
                      <button type="button" class="btn-test" (click)="testSorting(column.name, false)" [disabled]="testingSortField">
                        <span class="material-icons btn-test-icon" *ngIf="testingSortField !== column.name + '_ASC'">arrow_upward</span>
                        {{ testingSortField === column.name + '_ASC' ? 'TESTING...' : 'ASC' }}
                      </button>
                    </td>
                    <td >
                      <button type="button" class="btn-test" (click)="testSorting(column.name, true)" [disabled]="testingSortField">
                        <span class="material-icons btn-test-icon" *ngIf="testingSortField !== column.name + '_DESC'">arrow_downward</span>
                        {{ testingSortField === column.name + '_DESC' ? 'TESTING...' : 'DESC' }}
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <div class="test-section mt-4">
            <div class="test-section-title">Test New Filters:</div>
            <div class="filter-chips-container">
              <button type="button" class="btn-chip" (click)="testFilter('REQUIRED_DOCUMENTS')" [disabled]="testingFilter">Required Docs</button>
              <button type="button" class="btn-chip" (click)="testFilter('GENERATED_PERMITS')" [disabled]="testingFilter">Generated Permits</button>
              <button type="button" class="btn-chip" (click)="testFilter('REGISTRATIONS_TO_RENEW')" [disabled]="testingFilter">Registrations to Renew</button>
              <button type="button" class="btn-chip" (click)="testFilter('INSPECTIONS')" [disabled]="testingFilter">Inspections</button>
              <button type="button" class="btn-chip" (click)="testFilter('INSPECTIONS_TO_SCHEDULE')" [disabled]="testingFilter">Insp. To Schedule</button>
              <button type="button" class="btn-chip" (click)="testFilter('INSPECTIONS_TO_COMPLETE')" [disabled]="testingFilter">Insp. To Complete</button>
              <button type="button" class="btn-chip" (click)="testFilter('UPCOMING_INSPECTIONS_TO_COMPLETE')" [disabled]="testingFilter">Upcoming Insp.</button>
              <button type="button" class="btn-chip" (click)="testFilter('REGISTRATIONS_ABOUT_TO_EXPIRE')" [disabled]="testingFilter">Reg. About to Expire</button>
              <button type="button" class="btn-chip" (click)="testFilter('PENDING_PAYMENTS')" [disabled]="testingFilter">Pending Payments</button>
              <button type="button" class="btn-chip" (click)="testFilter('MY_APPLICATIONS')" [disabled]="testingFilter">My Applications</button>
              <button type="button" class="btn-chip" (click)="testFilter('SHARED_BY_ME')" [disabled]="testingFilter">Shared By Me</button>
              <button type="button" class="btn-chip" (click)="testFilter('SHARED_WITH_ME')" [disabled]="testingFilter">Shared With Me</button>
              <button type="button" class="btn-chip highlight" (click)="testFilter('RELEVANT_TO_USER')" [disabled]="testingFilter">Relevant To User</button>
              <button type="button" class="btn-chip danger" (click)="testFilter('NEEDS_MY_ATTENTION')" [disabled]="testingFilter">Needs My Attention</button>
            </div>
          </div>

          <div class="test-section mt-4">
            <div class="test-section-title">Test Custom Field Filter:</div>
            <div class="test-card">
              <div class="custom-filter-layout">
                <div class="filter-col">
                  <label class="field-label">Select Field</label>
                  <select class="custom-select" [(ngModel)]="customFilterField" [ngModelOptions]="{standalone: true}" [disabled]="testingCustomFilter">
                    <option value="">-- Choose a field --</option>
                    <option *ngFor="let field of availableFilterFields" [value]="field.name">{{ field.name || field.label }}</option>
                  </select>
                </div>
                <div class="filter-col operator-col">
                  <label class="field-label">Operator</label>
                  <select class="custom-select" [(ngModel)]="customFilterOperator" [ngModelOptions]="{standalone: true}" [disabled]="testingCustomFilter">
                    <option *ngFor="let op of filterOperators" [value]="op.value">{{ op.label }}</option>
                  </select>
                </div>
                <div class="filter-col">
                  <label class="field-label">Filter Value</label>
                  <input type="text" class="custom-input-sm" [(ngModel)]="customFilterValue" [ngModelOptions]="{standalone: true}" placeholder="Enter value..." [disabled]="testingCustomFilter" (keyup.enter)="testCustomFieldFilter()">
                </div>
                <div class="filter-btn-col">
                  <button type="button" class="btn save w-100 mt-26" (click)="testCustomFieldFilter()" [disabled]="testingCustomFilter || !customFilterField || !customFilterValue">
                    {{ testingCustomFilter ? 'TESTING...' : 'APPLY FILTER' }}
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="test-results-data-card mt-4" *ngIf="apiTestResults && apiTestResultColumns.length > 0">
            <div class="test-results-header-bar">
              <div class="left-section">
                <div class="d-flex align-items-center">
                  <span class="material-icons header-icon">table_chart</span>
                  <span class="title">API Test Results</span>
                  <span class="badge-count">{{ apiTestResultRows.length }} rows</span>
                </div>
                <small class="helper-text-muted d-block mt-1">{{ lastApiTestDescription }}</small>
              </div>
              <div class="right-actions">
                <button type="button" class="btn-clear-filter" (click)="clearGridFilters()" *ngIf="Object.keys(gridFilters).length > 0">
                  <span class="material-icons">filter_alt_off</span> Clear Filters
                </button>
                <button type="button" class="btn-close-results" (click)="clearApiTestResults()">
                  <span class="material-icons">close</span>
                </button>
              </div>
            </div>
            
            <div class="test-results-body">
              <table class="custom-table grid-table">
                <thead>
                  <tr>
                    <th class="text-center" style="width: 40px; border-right: 1px solid #e6e9eb;">#</th>
                    <th *ngFor="let column of apiTestResultColumns" class="sortable-th" (click)="sortGridByColumn(column.resultHeader)">
                      <div class="th-content">
                        <span>{{ column.name }}</span>
                        <span class="material-icons sort-icon" [class.active]="gridSortColumn === column.resultHeader">{{ getSortIcon(column.resultHeader) }}</span>
                      </div>
                    </th>
                  </tr>
                  <tr class="filter-row">
                    <th style="border-right: 1px solid #e6e9eb;"></th>
                    <th *ngFor="let column of apiTestResultColumns">
                      <input type="text" class="column-filter-input" [placeholder]="'Filter ' + column.name" [value]="gridFilters[column.resultHeader] || ''" (input)="onGridFilterChange(column.resultHeader, $any($event.target).value)" (click)="$event.stopPropagation()" />
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of apiTestResultRows; let i = index">
                    <td class="text-center text-muted" style="border-right: 1px solid #e6e9eb;">{{ i + 1 }}</td>
                    <td *ngFor="let column of apiTestResultColumns" [title]="getCellValue(row, column.resultHeader)">
                      {{ getCellValue(row, column.resultHeader) }}
                    </td>
                  </tr>
                  <tr *ngIf="apiTestResultRows.length === 0">
                    <td [attr.colspan]="apiTestResultColumns.length + 1" class="empty-results">
                      <span class="material-icons empty-icon">inbox</span>
                      <div>No results returned from API</div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

        </div>
      </ng-container>

      <div class="form-divider" style="margin-bottom: 16px;"></div>

      <div class="row" *ngIf="isEditMode && currentEditingDept?.id && canConfigureInspectionApp">
        <div class="col">
          <!-- Added by Amisha on 2026-10-07.
               Reason: render the inspection configuration link with shared Janus text and the Janus blue action style. -->
          <a
            [routerLink]="['inspection-app-columns']"
            class="btn inspection-config-link"
          >
            <wm-common-text [data]="{ text: 'Configure Inspection App Columns' }"></wm-common-text>
          </a>
        </div>
      </div>

      <div class="form-actions">
        <button type="button" class="btn cancel" (click)="closeInlineEditor()">CANCEL</button>
        <button type="button" class="btn save" [disabled]="isSaving" (click)="save()">
          <span *ngIf="isSaving">SAVING...</span>
          <span *ngIf="!isSaving">SAVE</span>
        </button>
      </div>

    </div>

    <section class="card table-card" *ngIf="!isLoading">
      <div class="table-responsive">
        <div class="table-head" role="row">
          <div class="th th-name">Name</div>
          <div class="th th-desc">Description</div>
          <div class="th th-icon">Icon</div>
          <div class="th th-status">Status</div>
          <div class="th th-actions">Actions</div> 
        </div>

        <div class="table-body-wrapper">
          <div class="table-body">
              
            <div class="empty-state" *ngIf="departments.length === 0">
              No Departments to display.
            </div>

            <div class="table-row" *ngFor="let d of departments">
              <div class="td td-name">{{ d.name }}</div>
              <div class="td td-desc" [innerHTML]="d.description || '-'"></div>
              <div class="td td-icon">
                <span class="material-icons icon-display" *ngIf="d.iconUrl">{{ d.iconUrl }}</span>
                <span *ngIf="!d.iconUrl" class="no-icon">-</span>
              </div>
              
              <div class="td td-status">
                <span class="material-icons status-icon-active" *ngIf="d.isEnabled">check_circle</span>
                <span class="material-icons status-icon-inactive" *ngIf="!d.isEnabled">error</span>
              </div>
              
              <div class="td td-actions">
                <a class="link action-edit" (click)="openEditEditor(d)">Edit</a>
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>

    <div class="standalone-loader" *ngIf="isLoading">
      <div class="spinner-border custom-blue-spinner" role="status"></div>
      <span class="loading-text">Loading departments...</span>
    </div>

  </div>

  <wm-common-confirmation-modal
    [data]="confirmData"
    (onYesClick)="confirmDelete()"
    (onNoClick)="cancelDelete()"
    [isApplicantMobileview]="true"
  ></wm-common-confirmation-modal>

</div>
